<template>
  <el-dialog
    title="数据导入"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" label-width="100px">
      <el-form-item label="文件上传">
        <el-button
          size="small"
          type="primary"
          @click="selectFile"
        >
          上传
        </el-button>
        <div class="upload-area">
          <el-upload
            ref="upload"
            class="upload-demo"
            drag
            action="#"
            accept=".xlsx,.xls"
            :limit="1"
            :file-list="fileList"
            :http-request="handleUpload"
            :on-remove="handleRemove"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处,或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="submitUpload"
        :loading="submitting"
      >
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ImportDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    tplId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      file: null,
      fileList: [],
      submitting: false,
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if (!val) {
        this.reset();
      }
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    selectFile() {
      this.$refs.upload.$refs["upload-inner"].handleClick();
    },
    handleUpload(param) {
      this.file = param.file;
    },
    handleRemove() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    submitUpload() {
      if (!this.file) {
        this.$message.error("请选择文件");
        return;
      }
      this.submitting = true;
      this.$emit("submit", {
        file: this.file,
        tplId: this.tplId,
        done: () => {
          this.submitting = false;
          this.dialogVisible = false;
          this.reset();
        },
        fail: () => {
          this.submitting = false;
          this.reset();
        },
      });
    },
    reset() {
      this.file = null;
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-area {
  margin-top: 10px;
}
</style>
